import book_1 from '../../../assets/img/other/home/book_1.jpg';
import book_2 from '../../../assets/img/other/home/book_2.jpg';

export const upBooks = [
  {
    category: [
      {
        kk: 'Мұражай',
        ru: 'Музей',
      },
    ],
    icon: '🏛️',
    title: {
      kk: 'Қазақ балалар кітабының мұражайы',
      ru: 'Музей казахской детской книги',
    },
    img_url: book_1,
    link_url: 'museum',
  },
  {
    category: [
      {
        kk: 'Динозаврлар',
        ru: 'Динозавры',
      },
    ],
    icon: '🦕',
    title: {
      kk: 'Қазақстанның динозаврлары',
      ru: 'Динозавры Казахстана',
    },
    img_url: book_2,
    link_url: 'dinosaurs',
  },
];
